import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import {
    ActivityNotificationsListComponent
} from 'src/app/board/activity/pages/activity-notifications-list/activity-notifications-list.component';

export const activityTypeParam = 'activityType';

/**
 * UrlMatcher permettant de :
 * - initialiser le module d'activité correspondant
 * - ajouter le paramètre de route 'activityType' avec le type d'activité.
 *
 * Le type d'activité défini dans les paramètres de route n'a pas de correspondance directe dans le back-end
 * @example
 * // Importe le module 'sales' et défini le paramètre de route {activityType: 'sales'}
 * {
 *   matcher: activityTypeMatcher('sales'),
 *   loadChildren: () => import('Chemin du module').then(m => m.ModuleClass)
 * }
 * @param activityType Type d'activité à matcher
 */
function activityTypeMatcher(activityType: string): (url: UrlSegment[]) => UrlMatchResult {
    return url => {
        const activityTypeSegment: UrlSegment = url[0];

        if (activityTypeSegment?.path !== activityType) {
            return null;
        }

        return {
            consumed: [activityTypeSegment],
            posParams: {
                [activityTypeParam]: new UrlSegment(activityType, {})
            }
        };
    };
}

const routes: Routes = [
    {
        path: 'settings',
        loadChildren: () => import('./activity-shared/activity-generals-settings/activity-generals-settings.module').then(m => m.ActivityGeneralsSettingsModule)
    },
    {
        path: 'stocks',
        loadChildren: () => import('./activity-shared/activity-stocks/activity-stocks.module').then(m => m.ActivityStocksModule)
    },
    {
        path: 'notifications',
        component: ActivityNotificationsListComponent
    },
    {
        matcher: activityTypeMatcher('sales'),
        loadChildren: () => import('./activity-sales/activity-sales.module').then(m => m.ActivitySalesModule)
    },
    {
        matcher: activityTypeMatcher('benefits'),
        loadChildren: () => import('./activity-benefits/activity-benefits.module').then(m => m.ActivityBenefitsModule)
    },
    {
        matcher: activityTypeMatcher('groups'),
        loadChildren: () => import('./activity-groups/activity-groups.module').then(m => m.ActivityGroupsModule)
    },
    {
        matcher: activityTypeMatcher('rentals'),
        loadChildren: () => import('./activity-rentals/activity-rentals.module').then(m => m.ActivityRentalsModule)
    },
    {
        matcher: activityTypeMatcher('savings'),
        loadChildren: () => import('./activity-savings/activity-savings.module').then(m => m.ActivitySavingsModule)
    },
    {
        matcher: activityTypeMatcher('media-libraries'),
        loadChildren: () => import('./activity-media-libraries/activity-media-libraries.module').then(m => m.ActivityMediaLibrariesModule)
    },
    {
        matcher: activityTypeMatcher('shared-resources'),
        loadChildren: () => import('./activity-shared-resources/activity-shared-resources.module').then(m => m.ActivitySharedResourcesModule)
    },
    {
        matcher: activityTypeMatcher('loans'),
        loadChildren: () => import('./activity-loans/activity-loans.module').then(m => m.ActivityLoansModule)
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ActivityRoutingModule {
}
